import { displayList, getAllItems, setAllItems } from '../../utils/storage/storage';

export default function MiddleareRoute() {

  setAllItems();
  getAllItems();

let path:any;
 for(let i = 0; i < displayList.length; i++){
   if(Object.entries(displayList[i].value).length === 0 ){
       path = displayList[i];
       break;
   }

 }
 return path;
    
 }


  

